module.exports = __webpack_public_path__ + "static/img/fun2.0b1dafe4.png";